module.exports = __webpack_public_path__ + "img/s2P37.fed15f88.png";